import React from 'react';
import { useAuth } from '../../context/AuthContext';
import Auth from '../Auth/Auth';

const ProtectedRoute = ({ children }) => {
  const { user, loading, isFirebaseEnabled } = useAuth();
  const isDemoMode = process.env.REACT_APP_DEMO_MODE === 'true';

  // Debug logging
  console.log('ProtectedRoute Debug:', {
    isDemoMode,
    isFirebaseEnabled,
    user: !!user,
    loading,
    envVar: process.env.REACT_APP_DEMO_MODE
  });

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        flexDirection: 'column',
        gap: '1rem'
      }}>
        <div className="animate-spin" style={{
          width: '2rem',
          height: '2rem',
          border: '2px solid var(--border-default)',
          borderTop: '2px solid var(--bg-accent)',
          borderRadius: '50%'
        }}></div>
        <p style={{ color: 'var(--text-secondary)' }}>Loading...</p>
      </div>
    );
  }

  // If demo mode is enabled, bypass authentication
  if (isDemoMode) {
    console.log('Demo mode enabled - bypassing authentication');
    return children;
  }

  // If Firebase is not configured, show the setup screen
  if (!isFirebaseEnabled) {
    console.log('Firebase not enabled - showing auth screen');
    return <Auth />;
  }

  // If Firebase is configured, require authentication
  console.log('Firebase enabled - checking user authentication');
  return user ? children : <Auth />;
};

export default ProtectedRoute;